import type { GapStrength } from 'features/trend-detection/features/benchmarking-agent/gap-strength-utils'

type Direction = 'leading' | 'lagging'

// Icon box: green (major+leading), red (major+lagging), amber (moderate), gray (minor)
export function getIconColor(
  direction: Direction,
  strength: GapStrength,
): string {
  if (direction === 'leading') {
    if (strength === 'major') return '#23896c'
    if (strength === 'moderate') return '#669614'
    return '#4f72a4'
  }
  if (strength === 'major') return '#ef4444'
  if (strength === 'moderate') return '#d98200'
  return '#4f72a4'
}

export function getIconBoxBackground(
  direction: Direction,
  strength: GapStrength,
): string {
  if (direction === 'leading') {
    if (strength === 'major')
      return 'linear-gradient(140.43deg, rgba(35, 137, 108, 0.2) 0%, rgba(35, 137, 108, 0.11) 92.14%), #FFFFFF'
    if (strength === 'moderate') return '#eef8d2'
    return '#edf1f6'
  }
  if (strength === 'major') return 'rgba(239, 68, 68, 0.12)'
  if (strength === 'moderate') return '#fff3e1'
  return '#edf1f6'
}

export function getIconBoxBorder(
  direction: Direction,
  strength: GapStrength,
): string {
  if (direction === 'leading') {
    if (strength === 'major') return 'rgba(35, 137, 108, 0.25)'
    if (strength === 'moderate') return 'rgba(102, 150, 20, 0.25)'
    return 'rgba(79, 114, 164, 0.25)'
  }
  if (strength === 'major') return 'rgba(239, 68, 68, 0.25)'
  if (strength === 'moderate') return 'rgba(217, 130, 0, 0.25)'
  return 'rgba(79, 114, 164, 0.25)'
}
